module.exports = __webpack_public_path__ + "static/media/vehicle.76c13e66.mp4";